import { CHART_COLORS } from '../constants/chartConstants'
import { formatMetricValue, formatTickValue } from '../utils/formatters'

const BASE_OPTIONS = {
  maintainAspectRatio: false,
  legend: { display: false },
  tooltips: {
    mode: 'index',
    intersect: false,
    displayColors: false,
  },
}

export function getChartOptions(metricType, isMobile) {
  const formatTick = value => formatTickValue(value, metricType)

  if (isMobile) {
    return {
      ...BASE_OPTIONS,
      tooltips: {
        ...BASE_OPTIONS.tooltips,
        callbacks: {
          title: () => null,
          label: ({ yLabel, xLabel }) => `${yLabel}: ${formatMetricValue(xLabel, metricType, true)}`,
        },
      },
      scales: {
        xAxes: [{
          gridLines: { color: CHART_COLORS.gridLine },
          ticks: { beginAtZero: true, precision: 0, callback: formatTick },
        }],
        yAxes: [{
          gridLines: { display: false },
          ticks: { fontSize: 20 },
        }],
      },
    }
  }

  return {
    ...BASE_OPTIONS,
    tooltips: {
      ...BASE_OPTIONS.tooltips,
      callbacks: {
        title: () => null,
        label: ({ xLabel, yLabel }) => `${xLabel}: ${formatMetricValue(yLabel, metricType, true)}`,
      },
    },
    scales: {
      xAxes: [{
        gridLines: { display: false },
        ticks: { maxTicksLimit: 15, maxRotation: 45 },
      }],
      yAxes: [{
        gridLines: { color: CHART_COLORS.gridLine },
        ticks: { beginAtZero: true, precision: 0, callback: formatTick },
      }],
    },
  }
}

export function getBarColors(labels, boostPeriods) {
  return labels.map(date => {
    const isBoosted = boostPeriods.some(p => date >= p.startDate && date <= p.endDate)
    return isBoosted ? CHART_COLORS.boost : CHART_COLORS.normal
  })
}
